import {Component, OnInit, OnDestroy ,ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {Formatters} from 'angular-slickgrid';
import {NgbModal , NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-role-user-action',
  templateUrl: './role-user-action.component.html',
  styleUrls: ['./role-user-action.component.css']
})
export class RoleUserActionComponent implements OnInit, OnDestroy {

  displayed = true;
  totalData = 0;
  show: boolean;
  selected: number;
  respObject: any;

  clientSelected: number;
  clients: any[];
  role: any[];
  users: any[];
  userSelected: string;
  userName: string;
  roleName: string;
  roleSelected: number;
  actions: any[];
  displayData: any;
  notAdmin = true;


  add = false;
  del = false;
  edit = false;
  view = false;

  isError = false;
  errorMessage: string;

  private clientName: any;

  private notifier: NotifierService;
  private clientId: any;
  private baseFlag: any;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private userAuth: Subscription;
  private adminAuth: Subscription;
  dataLoaded: boolean;
  isLoading = false;
  userId:number;
  searchUser: FormControl = new FormControl();
  showSearch = true;
  userDtl = [];

  searchData: FormControl = new FormControl();
  userSelected1:any;
  usrs1 = [];
  userName1: string;
  @ViewChild('scarch_content') private scarch_content;
  private searchModalReference: NgbModalRef;




  constructor(private _rest: RestApiService, private messageService: MessageService,
              private route: Router, private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          if (this.baseFlag) {
            if (!this.del) {
              this.notifier.notify('error', 'You do not have delete permission');
            } else {
              this.deleteItem(item);
            }
          } else {
            if (!this.messageService.del) {
              this.notifier.notify('error', 'You do not have delete permission');
            } else {
              this.deleteItem(item);
            }
          }
          break;
      }
    });
    this.messageService.getUserAuth().subscribe(details => {
      // console.log(JSON.stringify(details));
      if (details.length > 0) {
        this.add = details[0].addFlag;
        this.del = details[0].deleteFlag;
        this.view = details[0].viewFlag;
        this.edit = details[0].editFlag;
      }
    });
    this.messageService.getSelectedItemData().subscribe(selectedTitles => {
      if (selectedTitles.length > 0) {
        this.show = true;
        this.selected = selectedTitles.length;
      } else {
        this.show = false;
      }
    });
  }

  deleteItem(item) {
    if (confirm('Are you sure?')) {
      this._rest.deleteRoleUserAction({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.messageService.sendAfterDelete(item.id);
        } else {
          this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.respObject.errorMessage);
      });
    }
  }

  ngOnInit() {
    this.dataLoaded = false;
    // this.messageService.setGridWidth(1000);
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'Maintain Role Mapping with Action',
      openModalButton: 'Map Action With Role',
      searchModalButton: 'Search',
      breadcrumb: 'RoleAction',
      folderName: 'All Mapped Action with role',
      tabName: 'Role Action Mapping'
    };

    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, maxWidth: 30, filterable: true},
      {
        id: 'client', name: 'Client ', field: 'client', sortable: true, filterable: true
      },
      {
        id: 'role', name: 'Role', field: 'role', sortable: true, filterable: true
      },
      {
        id: 'user', name: 'User', field: 'user', sortable: true, filterable: true
      },
      {
        id: 'action', name: 'Action', field: 'action', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
      this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
        if (details.length > 0) {
          this.add = details[0].addFlag;
          this.del = details[0].deleteFlag;
          this.view = details[0].viewFlag;
          this.edit = details[0].editFlag;
          this.clientId = details[0].clientId;
          this.baseFlag = details[0].baseFlag;
          this.onPageLoad();
        }
      });
    }
    this._rest.getActions().subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        for (let i = 0; i < this.respObject.actions.length; i++) {
          this.respObject.actions.checked = false;
        }
        this.actions = this.respObject.actions;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });

    if (this.clientId !== 1) {
      this.clientSelected = this.clientId;
    }
    this.searchUser.valueChanges.subscribe(
      psOrName => {
          this.isLoading = true;
          const role_id = 0;
          if (psOrName !== '') {
              this._rest.searchAllUser(this.clientSelected, psOrName, role_id).subscribe((res1) => {
                  this.respObject = res1;
                  this.isLoading = false;
                  if (this.respObject.success) {
                      this.users = this.respObject.details;
                  } else {
                      this.notifier.notify('error', this.respObject.errorMessage);
                  }
              }, (err) => {
                  this.isLoading = false;
                  this.notifier.notify('error', this.messageService.SERVER_ERROR);
              });
          } else {
              this.isLoading = false;
              this.userName = '';
              this.users = [];
          }
      });
  }

  onPageLoad() {
        if (this.baseFlag) {
          this.notAdmin = false;
          this._rest.getClient().subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
              this.isError = false;
              this.respObject.clients.unshift({id: 0, name: 'Select Client'});
              this.clients = this.respObject.clients;
              this.clientSelected = 0;
            } else {
              this.isError = true;
              this.errorMessage = this.respObject.errorMessage;
            }
          }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
          });
        } else {
          // this.add = this.messageService.add;
          // this.del = this.messageService.del;
          // this.view = this.messageService.view;
          // this.edit = this.messageService.edit;
          this.clientSelected = this.clientId;
          this._rest.getRoleClientWise(this.clientSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
              this.isError = false;
              this.respObject.roles.unshift({id: 0, name: 'Select Role'});
              this.role = this.respObject.roles;
              this.roleSelected = 0;
            } else {
              this.isError = true;
              this.errorMessage = this.respObject.errorMessage;
            }
          }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
          });
        }
    this.getTableData();
  }

  openModal(content) {
    for (let j = 0; j < this.actions.length; j++) {
      this.actions[j].checked = false;
    }
    if (this.baseFlag) {
      if (!this.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
        this.isError = false;
        this.clientSelected = 0;
        this.roleSelected = 0;
        this.modalService.open(content).result.then((result) => {
        }, (reason) => {

        });
      }
    } else {
      if (!this.messageService.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
        this.roleSelected = 0;
        this.isError = false;
        this.modalService.open(content).result.then((result) => {
        }, (reason) => {

        });
      }
    }
  }


  searchModal()  {
    
    if (this.baseFlag) {
      
        this.userSelected1='';
        this.searchModalReference = this.modalService.open(this.scarch_content);
        this.searchModalReference.result.then((result) => {
        }, (reason) => {

        });

    } else {

    
        this.userSelected1 = '';
        this.searchModalReference = this.modalService.open(this.scarch_content);
        this.searchModalReference.result.then((result) => {
        }, (reason) => {

        });

    }
  }


  get selectedOptions() {
    return this.actions
      .filter(opt => opt.checked)
      .map(opt => opt.id);

  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  getUserDetails() {
    for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].login_name === this.userSelected) {
            this.userId = this.users[i].id;
            this.userName = this.users[i].name;
        }
    }
}


search() {
  this._rest.searchAllRoleUserActionMapping( this.userSelected1, this.clientId).subscribe((res1) => {
    this.respObject = res1;
    this.isLoading = false;
    if (this.respObject.success) {
      this.usrs1 = this.respObject.details;
      this.messageService.setTotalData(this.usrs1.length);
      this.messageService.setGridData(this.usrs1);
      this.searchModalReference.close();

    } else {
      this.notifier.notify('error', this.respObject.errorMessage);
    }
  }, (err) => {
    this.isLoading = false;
    this.notifier.notify('error', this.messageService.SERVER_ERROR);
  });
}



  save() {
    const data = {
      clientId: this.clientSelected,
      roleId: this.roleSelected,
        refer_user_id: this.userId,
      createdBy: this.messageService.getUserId(),
      actionIds: this.selectedOptions
    };
    if (!this.messageService.isBlankField(data) && this.selectedOptions.length > 0) {
      this._rest.mapRoleUserAction(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.isError = false;
          this.nextOffset = 0;
          this.page_no = 0;
          this.getTableData();
          if (this.baseFlag) {
            this.clientSelected = 0;
          }
          this.roleSelected = 0;
          this.userSelected = '';
          for (let j = 0; j < this.actions.length; j++) {
            this.actions[j].checked = false;
          }
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded=false;
    if (this.baseFlag) {
      if (!this.view) {
        this.notifier.notify('error', 'You do not have view permission');
      } else {
        // this.getNewTableData();
        this._rest.getRoleUserActionMap(offset, this.pageSize, paginationType).subscribe((res) => {
          this.respObject = res;
          this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
          this.notifier.notify('error', this.respObject.errorMessage);
        });
      }
    } else {
      if (!this.messageService.view) {
        this.notifier.notify('error', 'You do not have view permission');
      } else {
        // this.getNewTableData();
        this._rest.getRoleUserActionMapWithClientId(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
          this.respObject = res;
          this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
          this.notifier.notify('error', this.respObject.errorMessage);
        });
      }
    }
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

  onClientChange(value: any) {
    this.clientName = this.clients[value].name;
    this.userSelected = '';
    this.userName = '';
    this._rest.getRoleClientWise(this.clientSelected).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.roles.unshift({id: 0, name: 'Select Role'});
        this.role = this.respObject.roles;
        this.roleSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onRoleChange(selectedIndex: any) {
    this.roleName = this.role[selectedIndex].name;
    this.userSelected = '';
  }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
    if (this.adminAuth) {
      this.adminAuth.unsubscribe();
    }
  }
}
